module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section03_03_beach-photo-3b646f6c57229381c2c0f2bec2ec737d.jpg";